import { Button } from 'antd';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import styled from 'styled-components';

export const RibbonContainer = styled.div`
  width: 100%;
`;

export const ProductCardCompactContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: grid;
    grid-template-columns: 150px 1fr 550px;
    align-items: stretch;
    gap: 16px;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  width: 100%;
  margin-bottom: 8px;

  .product-header {
    min-width: 0;
  }

  .offer-info {
    .validity-info {
      flex: 0;
      align-items: flex-start;
    }

    .producer-info {
      flex: 1;
    }
  }

  .product-offer-info-desktop {
    display: none;

    @media (min-width: ${BREAKPOINTS.tabletMini}) {
      display: flex;
    }
  }
`;

export const ProductCardCompactCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: grid;
    grid-template-columns: 150px 1fr 400px;
    align-items: stretch;
    gap: 16px;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const ProductCompactActionsCol = styled.div`
  display: none;
  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    height: 100%;
    gap: 12px;
    box-sizing: border-box;
    min-width: 0;
    padding-right: 8px;

    @media (min-width: ${BREAKPOINTS.desktop}) {
      .product-card-actions {
        flex-direction: row;

        .controls-section {
          display: flex;
          flex-direction: column;
          gap: 5px;

          .sale-type-grid {
            gap: 0px;

            .sale-type-label {
              font-size: 0.625rem;
              margin-right: 0;

              span {
                padding: 0;
                padding-right: 8px;
              }
            }

            .sale-type-price {
              font-size: 0.75rem;
            }
          }
        }

        .buttons-section {
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 5px;
          width: 210px;
          flex-shrink: 0;
          margin-left: auto;

          .desktop-text {
            display: none;
          }

          .mobile-text {
            display: block;
          }
        }
      }
    }
  }
`;

export const ProductCompactPurchaseActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 200px;
`;

export const ProductCompactQuantityInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .ant-input {
    text-align: center;
    border-radius: 4px;
  }

  .quantity-label {
    font-size: 12px;
    color: #666;
    text-align: center;
  }
`;

export const ProductCompactCartButton = styled(Button)`
  width: 100%;
  height: 36px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &.ant-btn-primary {
    background-color: #f78e1e;
    border-color: #f78e1e;

    &:hover {
      background-color: #ff9a32;
      border-color: #ff9a32;
    }
  }
`;

export const ProductCompactImageSection = styled.div`
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  overflow: hidden;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    min-height: 128px;
    min-width: 178px;
    margin: -12px;
  }
`;

export const ProductCompactContentSection = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    border-right: 1px solid #f0f0f0;
    border-left: 1px solid #f0f0f0;
    margin-top: -12px;
    margin-bottom: -12px;
    padding-top: 12px;
    padding-bottom: 12px;
    min-height: fit-content;
  }
`;

export const ProductCompactTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-height: 30px;
  flex-wrap: wrap;

  .product-header {
    min-width: 0;
    overflow: hidden;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    border-bottom: 1px solid #f0f0f0;
    padding-left: 8px;

    .product-header {
      flex: 1;
      min-width: 0;
    }
    .product-offer-info-desktop {
      flex: none;
    }
  }
`;

export const ProductCompactOfferRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #666;
`;

export const ProductCompactDetails = styled.div`
  margin-left: -50px;
  flex: 1;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    margin-left: 0;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    padding-left: 8px;
  }
`;

export const ProductCompactQualityRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  .desktop-multiple {
    display: none;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    justify-content: flex-start;

    .desktop-multiple {
      display: flex;
      justify-content: flex-start;
    }
  }
`;

export const ProductCompactQualitySection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    flex: none;
    flex-direction: row;
    align-items: flex-start;
  }

  .quality-info {
    align-self: flex-start;
    display: flex;
    flex-direction: row;
    gap: 8px;

    .quality-item,
    .packaging-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .label {
      color: #000;
    }
  }
`;

export const CaretContainer = styled.div`
  display: none;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: block;
    border: 1px solid;
    height: 12px;
    width: 12px;
    font-size: 0.5rem;
  }
`;

export const ProductCompactPriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-left: -50px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    margin-left: 0;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: none;
  }

  .price-container {
    width: auto;
    gap: 8px;
  }

  .icon-button {
    padding: 0 8px !important;
    width: 32px !important;
    height: 32px !important;
  }

  .detail-button {
    display: inline-block;
    flex: unset;
    width: fit-content;
  }

  .buy-button-wrapper {
    flex: 0;
  }
`;

export const ProductCompactPriceSection = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const ProductCompactFreightSection = styled.div`
  font-size: 12px;
  color: #666;
`;

export const ProductCompactActionsSection = styled.div`
  display: flex;
  gap: 8px;
`;

export const ProductCompactExpandedSection = styled.div<{
  isExpanded: boolean;
}>`
  overflow: hidden;
  transition: max-height 0.3s ease;
  border-radius: 4px;
  max-height: ${(props) => (props.isExpanded ? '200px' : '0')};
  margin-top: ${(props) => (props.isExpanded ? '8px' : '0')};
  display: ${(props) => (props.isExpanded ? 'block' : 'none')};
`;

export const ProductCompactExpandedContent = styled.div`
  font-size: 12px;
  color: #666;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    flex-direction: row;
  }
`;

export const ProductCompactExpandedRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  @media (min-width: ${BREAKPOINTS.desktop}) {
    justify-content: flex-start;
  }
`;

export const ProductCompactExpandedItem = styled.div<{
  hideOnDesktop?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 2px;

  > strong {
    font-size: 10px;
    font-weight: 400;
    color: #8c8c8c;
  }

  > span {
    font-size: 10px;
    font-weight: 400;
    color: #000000;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    ${(props) => (props.hideOnDesktop ? 'display: none' : '')};
  }
`;

export const ProductCompactExpandedObservation = styled.div`
  font-size: 10px;
  line-height: 1.4;
  color: #000 !important;

  > strong {
    font-weight: 400;
    color: #8c8c8c;
  }

  @media (min-width: ${BREAKPOINTS.desktop}) {
    display: flex;
    flex-direction: column;
  }
`;

export const ProductCompactExpandedDivider = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  margin-top: 4px;
`;
